import { motion } from "framer-motion";
import SEO from "@/components/SEO";

const sections = [
  {
    label: "01",
    title: "Health Disclaimer",
    body: "Services provided support fitness, mobility, recovery, and athletic performance. They are not medical treatment. Nothing offered here should be interpreted as medical advice, diagnosis, or therapy. If you have a medical condition, injury, or health concern, please consult a qualified medical professional before beginning or continuing any program.",
  },
  {
    label: "02",
    title: "Cancellation Policy",
    body: "A minimum of 24-hour notice is required to cancel or reschedule any session. Cancellations made with less than 24 hours' notice, as well as no-shows, will not be refunded pre paid amount. Repeated late cancellations may impact future booking availability.",
  },
  {
    label: "03",
    title: "Payment Policy",
    body: "Partial payment is due before each session. All sessions must be paid upfront and are non-refundable. Prices and package terms will be communicated in writing before purchase and dependant on the service you require.",
  },
  {
    label: "04",
    title: "Waiver & Consent",
    body: "All clients are required to complete a liability waiver, a PAR-Q / health screening form, and a consent form for assisted stretching (Fascial Stretch Therapy) prior to their first session. These documents ensure safe, appropriate programming and clear communication of expectations.",
  },
];

export default function Policies() {
  return (
    <div>
      <SEO
        title="Policies & Disclaimer"
        path="/policies"
        description="Health disclaimer, scope of practice, cancellation policy, payment policy, and waiver information for BW MATRIX."
      />
      <section className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16 md:pb-24">
          <p className="label-eyebrow mb-6">Policies / Disclaimer</p>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="font-display uppercase font-bold text-5xl sm:text-6xl md:text-7xl leading-[0.9] tracking-tight text-white max-w-4xl"
          >
            The<br />
            <span className="text-white/50">fine print.</span>
          </motion.h1>
        </div>
      </section>

      <section>
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <ul className="border-t border-white/10">
            {sections.map((s) => (
              <li key={s.label} className="border-b border-white/10 py-10 grid grid-cols-1 md:grid-cols-12 gap-6">
                <div className="md:col-span-2">
                  <p className="font-display text-white/30 text-2xl font-bold">{s.label}</p>
                </div>
                <div className="md:col-span-10">
                  <h2 className="font-display uppercase text-2xl md:text-3xl font-bold text-white leading-tight tracking-tight">
                    {s.title}
                  </h2>
                  <p className="mt-4 text-zinc-400 leading-relaxed">{s.body}</p>
                </div>
              </li>
            ))}
          </ul>

          <p className="mt-12 text-xs text-zinc-500 leading-relaxed uppercase tracking-[0.2em]">
            Last updated: {new Date().toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" })}
          </p>
        </div>
      </section>
    </div>
  );
}
